import moment from 'moment';
import { Button, Drawer, message, Modal, Popconfirm, Statistic, Table, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import { GetPendingPayments } from '../../../apis/Brand/Credit/GetPendingPayments';
import { useGlobalState } from '../../../store/state';
import CurrencyIcon from '../../Common/CurrencyIcon';
import CreditPaymentForm from './CreditPaymentForm';
import './PendingPaymentsComponent.styles.scss';

const PendingPaymentsComponent = () => {
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');

  const [visible, setVisible]= useState(false);
  const [cost, setCost]= useState(0);
  const [campId, setCampId]= useState('');
  const [pendingCamps, setPendingCamps] = useState({
    pager: {
      page: 1,
    },
    data: [],
  });
  // const showPaymentDrawer = () =>{
  //     console.log("showing")
  //     setVisible(true)
  // }

  const closePaymentDrawer = () =>{
    setVisible(false);
    setCost(undefined);

    // @note: re-fetech pendingpayments after payment completion
    pendingPayment(1);
  };
  const columns = [
    {
      title: 'Campaign Name',
      dataIndex: 'name',
      render: (_v, { key }) =>{
        return <div className=""><strong>{_v}</strong> <div>{key}</div></div>;
      },
    },
    {
      title: 'Date & time',
      dataIndex: 'date',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: {
        compare: (a, b) => a.status - b.status,
        multiple: 3,
      },
      render: (_v) =>{
        if (_v === 'Approved') {
          return <Tag color="green">{_v}</Tag>;
        } else {
          return <Tag color="gold">{_v}</Tag>;
        }
      },
    },
    {
      title: 'Cost',
      dataIndex: 'cost',
      sorter: {
        compare: (a, b) => a.cost - b.cost,
        multiple: 2,
      },
      render: (_v) =>{
        return (
          <div className="text-left">
            <span className="d-inline-block"
              style={{ verticalAlign: '1px' }}>
              {CurrencyIcon()}
            </span>
            <Statistic className="custom_number_format"
              value={_v}
              precision={2}/>
          </div>
        );
      },
    },
    {
      title: 'Action',
      key: 'makepayment',
      fixed: 'right',
      width: 150,
      render: (v) => (
        <Button
          className="common_button outlined small py-2"
          onClick={() =>triggerPaymentModule(v.cost, v.key)}
        >
                  Make Payment
        </Button>
      ),
    },
  ];

  // note get pending payment details
  const pendingPayment = (page) => {
    GetPendingPayments(user.accessToken, company.selected.id, page).then(({ status, response }) =>{
      console.log('response==> ', response);
      if (status === 200) {
        const _data = response.pendingPaymentCampaigns.map(({ budget, campaignid, campaignstatus, name, createdAt }) =>{
          return {
            key: campaignid,
            name: name,
            status: campaignstatus,
            cost: budget,
            date: moment(createdAt).format('Do MMM YYYY'),
          };
        });
        console.log('data', _data);

        // @note: storing in a state
        setPendingCamps({
          ...pendingCamps,
          pager: {
            hasNextPage: response.hasNextPage,
            hasPrevPage: response.hasPrevPage,
            page: response.page,
            nextPage: response.nextPage,
            prevPage: response.prevPage,
            totalPages: response.totalPages,
            limit: response.limit,
            transactionsCount: response.transactionsCount,
          },
          data: _data,
        });
      } else {
        message.error('There is some issue while retriving pending payments');
      }
    });
  };

  // @note: getting pending payment details
  useEffect(()=>{
    pendingPayment(1);
  }, []);

  // @note: page changing if more than
  const changePage = (page) =>{
    // const {range,filter} = txnState
    // getTransactionDetails(range,filter,page)
  };

  // @note: trigger payment module
  const triggerPaymentModule = (cost, id)=>{
    // if(company.credit.balance >= cost){
    //   Modal.confirm({
    //     title:"You Have enough balance in wallet",
    //     content:"We strongly recommand to use balance in wallet first",
    //     okText:"Pay from Wallet",
    //     maskClosable:true,
    //     onOk:makeWalletPayment,
    //     // onCancel:"Later",
    //     closable:true
    //   })
    // }else{
    setCost(cost);
    setCampId(id);
    setVisible(true);
    // }
  };

  // @make a wallet payment
  const makeWalletPayment = () =>{
    // @note: [WIP] implement Wallet Payment from here

  };


  return (
    <>
      <div className="common_card p-3 pending_payments h-100">
        <div className="row align-items-center">
          <div className="col-12">
            <h5 className="pending_payments--title">Pending Payments</h5>
            <p className="pending_payments--subtitle">Your campaign is all set and ready to go.</p>
          </div>
          <div className="col-12">
            <Table
              columns={columns}
              dataSource={pendingCamps.data}
              pagination={{
                showSizeChanger: false,
                current: pendingCamps.pager.page,
                total: pendingCamps.pager.transactionsCount,
                onChange: (v) => changePage(v),
              }}
            />
          </div>
        </div>
      </div>
      <CreditPaymentForm
        visible={visible}
        onClose={closePaymentDrawer}
        cost={cost}
        campId={campId}
        pendingPayment
      />
    </>
  );
};

export default PendingPaymentsComponent;
